const KEY = (uid) => `kabch_sel_drafts_${uid}`;

export const loadDrafts = (uid) => {
  try { return JSON.parse(localStorage.getItem(KEY(uid)) || "[]"); } catch { return []; }
};

// Returns "ok" | "no_photos" (saved without photos due to storage quota) | "fail"
export function saveDraft(uid, draft) {
  const list = loadDrafts(uid).filter((d) => d.client_key !== draft.client_key);
  try { localStorage.setItem(KEY(uid), JSON.stringify([...list, draft])); return "ok"; } catch { /* quota */ }
  try { localStorage.setItem(KEY(uid), JSON.stringify([...list, { ...draft, photos: [], photos_dropped: true }])); return "no_photos"; } catch { return "fail"; }
}

export const removeDraft = (uid, key) => localStorage.setItem(KEY(uid), JSON.stringify(loadDrafts(uid).filter((d) => d.client_key !== key)));
